/* eslint-disable jsx-a11y/anchor-is-valid */
import { useInstance } from "@meraki-internal/react-dependency-injection";
import { DataModelV2 } from "./data";
import { AuthProvider } from "./HeaderAndNavigationBar";
import { IWebsiteClub } from "./IWebsiteDataV3";
import { useSubscription } from "@meraki-internal/state";

interface IFooterLink {
    name: string;
    url?: string;
    onClick?: () => void;
    hidden?: boolean;
}

const FooterLinkSection: React.FC<{ title: string; links: IFooterLink[] }> = ({ title, links }) => {
    return (
        <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">

            <div className="footer-widget clearfix">

                <div className="sidebar-widget-wrapper">

                    <div className="footer-widget-header clearfix">
                        <h3>{title}</h3>
                    </div>


                    <ul className="footer-useful-links">
                        {links.map(({ url, name, onClick, hidden }) => (
                            <li style={hidden ? { display: 'none' } : {}}>
                                <a
                                    href={url || undefined}
                                    style={{ cursor: 'pointer'}}
                                    onClick={e => {
                                        if (onClick){
                                            onClick();
                                        }
                                    }}
                                    rel="noreferrer"
                                    target={url && !url.startsWith('#') ? '_blank' : ''}
                                >
                                    <i className="fa fa-angle-double-right fa-footer"></i>
                                    {name}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export const Footer: React.FC = () => {
    const authProvider = useInstance(AuthProvider);

    const data = useInstance(DataModelV2);
    useSubscription(() => data);

    const competitions: { name: string; clubs: IWebsiteClub[]; }[] = [
        {
            name: 'Vex Robotics Competition',
            clubs: data.getAllVexClubs()
        },
        // {
        //     name: 'First Technical Challenge',
        //     clubs: data.getAllFTCClubs().filter(() => false)
        // },
        // {
        //     name: 'First Robotics Competition',
        //     clubs: data.getAllFRCClubs()
        // },
        {
            name: 'Vex Univerisity',
            clubs: data.getAllVexUClubs()
        }
    ]
        .sort((comp1, comp2) => {
            const comp1Teams = comp1.clubs.reduce((sum, club) => sum + club.teams.length, 0);
            const comp2Teams = comp2.clubs.reduce((sum, club) => sum + club.teams.length, 0);
            return comp2Teams - comp1Teams;
        })
        .map(comp => {
            return {
                ...comp,
                clubs: comp.clubs.sort((club1, club2) => club1.name.localeCompare(club2.name))
            }
        });

    // sort based on number of teams (then alpha sort)
    return (
        <footer id="contact">

            <section className="footer-widget-area">

                <div className="container">

                    <div className="row">


                        <div className="col-lg-3 col-md-3 col-sm-12">

                            <div className="footer-widget clearfix">

                                <div className="sidebar-widget-wrapper">

                                    <div className="footer-widget-header clearfix">
                                        <h3>Teams</h3>
                                    </div>


                                    <ul className="footer-useful-links" id="teams-list">
                                        {competitions.map(({ name, clubs }) => (
                                            <li key={name}>
                                                {name}
                                                <ul>
                                                    {clubs.map(club => (
                                                        <li key={club.clubId}>
                                                            <div
                                                                style={{ height: 28, cursor: data.canAdminister(club.clubId) ? 'pointer' : 'default' }}
                                                                onClick={() => {
                                                                    if (data.canAdminister(club.clubId)) {
                                                                        window.location.hash = `/clubs/${club.clubId}`
                                                                    }

                                                                }}
                                                            >
                                                                {club.clubLink && (
                                                                    <a href={club.clubLink} target="_blank" rel="noreferrer">
                                                                        <i className="fa fa-angle-double-right fa-footer" />
                                                                        {club.name}
                                                                    </a>
                                                                )}
                                                                {!club.clubLink && (
                                                                    <span>{club.name}</span>
                                                                )}

                                                                {data.canAdminister(club.clubId) && (
                                                                    <span style={{ marginLeft: 10 }}>
                                                                        <i className="fa fa-gear" />
                                                                    </span>
                                                                )}
                                                            </div>
                                                            {/* <ul>
                                                                {club.teams.map(team => (
                                                                    <li key={team.url}>
                                                                        <a href={team.url}>
                                                                            <i className="fa fa-angle-double-right fa-footer"></i>
                                                                            {team.name}
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                            </ul> */}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </li>
                                        ))}
                                    </ul>

                                </div>

                            </div>

                        </div>
                        <FooterLinkSection
                            title="Students"
                            links={[

                                { name: 'Building Tips', url: 'https://www.youtube.com/watch?v=akDIvT_dPgg' },
                                { name: 'Game Manual', url: 'https://v5rc-kb.recf.org/hc/en-us/articles/9652912628631-Game-Manual-and-Resources-for-VEX-V5-Robotics-Competition-Teams' },
                                { name: 'Dex (Hero Bot)', url: 'https://kb.vex.com/hc/en-us/articles/40241402832660-An-Introduction-to-Dex-The-V5RC-Push-Back-Hero-Bot' },
                                { name: 'Official Q&A', url: 'https://www.robotevents.com/V5RC/2025-2026/QA' },
                                { name: 'Forum', url: 'https://www.vexforum.com/' },

                                { name: 'Drive Team Training', url: 'https://v5rc-kb.recf.org/hc/en-us/articles/9652732380055-VEX-V5-Robotics-Competition-Drive-Team-Training-Courses-2025-26-Push-Back' },
                                { name: 'First Tournament Welcome Video', url: 'https://www.youtube.com/watch?v=9iME2H6TO5M' },
                                { name: 'First Alliance Selection Video', url: 'https://www.youtube.com/watch?v=3i-Z2ucZRqM' },

                                { name: 'Interview Rubric', url: 'https://kb.roboticseducation.org/hc/en-us/articles/4971345633815-Judging-Resource-Team-Interview-Rubric' },
                                { name: 'Eng Notebook Rubric', url: 'https://kb.roboticseducation.org/hc/en-us/articles/4461349729047-Judging-Resource-Engineering-Notebook-Rubric' },
                                { name: 'Robotics Honor Society', url: 'https://kb.roboticseducation.org/hc/en-us/articles/4660166776215-International-Robotics-Honor-Society' },
                                { name: 'Amazon Future Engineer scholarship', url: 'https://www.amazonfutureengineer.com/scholarships' },
                            ]}
                        />
                        <FooterLinkSection
                            title="Parents"
                            links={[
                                { name: 'Student Centered', url: 'https://v5rc-kb.recf.org/hc/en-us/article_attachments/27884439058711' },
                                { name: 'Vex Primer', url: 'https://kb.roboticseducation.org/hc/en-us/articles/8296906601751-VEX-Tournaments-101-A-Primer-for-Parents' },
                                { name: 'Vex Via', url: 'https://v5rc-kb.recf.org/hc/en-us/articles/9658766476567-Apps-for-the-VEX-Robotics-World-Championship#vex-via-hzBNP' },
                                { name: 'Push Back Primer', url: 'https://www.vexrobotics.com/v5/competition/vrc-current-game?srsltid=AfmBOoryJfFhZ4RtE27MmiYniFhfDaAZRn58qWonbg-_jkDqhv4Tbo7G' },
                            ]}
                        />
                        <FooterLinkSection
                            title="Coaches"
                            links={[
                                { name: 'REC Announcements', url: 'https://kb.roboticseducation.org/hc/en-us/articles/32326699835799-2025-2026-Season-Updates-for-VEX-Robotics-Competition-Programs' },
                                { name: 'Coach Excellence', url: 'https://v5rc-kb.recf.org/hc/en-us/articles/22840279124631-Commitment-to-Coach-Excellence' },
                                { name: 'Student Centered Policy', url: 'https://viqrc-kb.recf.org/hc/en-us/articles/9778591033879-Student-Centered-Policy' },
                                // { name: 'Sign in as Coach', onClick: () => authProvider.authenticate(), hidden: Boolean(authProvider.user) },
                                // { name: 'Sign out as Coach', onClick: () => authProvider.logout(), hidden: !authProvider.user },
                            ]}
                        />
                        <FooterLinkSection
                            title="Volunteers"
                            links={[
                                { name: 'Apply for Grant for New Team', url: 'https://forms.gle/ZxTEMZumaxv9imtL6' },
                                { name: 'Volunteer for a team', url: 'https://forms.gle/bg4kxpXxoHdsQNA89' },
                                { name: 'Certify as Head Referee', url: 'https://kb.roboticseducation.org/hc/en-us/articles/4461384721815-VEX-V5-Robotics-Competition-Head-Referee-Training-Certification-Course' },
                                { name: 'Certify as Judge Advisor', url: 'https://kb.roboticseducation.org/hc/en-us/articles/5429253866903' },
                                { name: 'Certify as Event Partner', url: 'https://kb.roboticseducation.org/hc/en-us/articles/5458612573207-Event-Partner-Training-Certification-Course' },
                                { name: 'Host a workshop', url: 'mailto:support@blackhillsrobotics.org?subject=I%20am%20interested%20in%20hosting%20a%20workshop%20for%20Black%20Hills%20Robotics%20students&body=I%20would%20like%20to%20host%20a%20workshop%20on%20any%20of%20the%20following%20topics%0D%0A%0D%0A%0D%0AWould%20that%20be%20helpful%3F%20How%20do%20we%20make%20it%20happen%3F' },
                                { name: 'Help with Administration', url: "mailto:support@blackhillsrobotics.org?subject=I%20am%20interested%20in%20helping%20out%20with%20Logistics%20and%20Administration&body=I%20would%20like%20to%20help%20out%20with%20Logistics%20and%20Administration.%20I%20am%20open%20to%20the%20following%20tasks%20(remove%20those%20you%20aren't%20interested%20in)%0D%0A%20-%20Accounting%20%2F%20Treasury%0D%0A%20-%20Registering%20for%20Tournaments%0D%0A%20-%20Booking%20and%20coordinating%20hotel%20%20%2F%20travel%0D%0A%20-%20Triaging%20inbound%20communication%0D%0A%0D%0AWould%20that%20be%20helpful%3F%20How%20do%20I%20get%20started%3F" },
                                { name: 'Join the Board', url: "mailto:support@blackhillsrobotics.org?subject=I%20am%20interested%20in%20joining%20the%20Black%20Hills%20Robotics%20Foundation%20Board&body=I%20think%20I%20would%20be%20a%20good%20fit%20to%20join%20the%20Black%20Hills%20Robotics%20Foundation%20Board%20because...%0D%0A%0D%0APlease%20let%20me%20know%20if%20%2F%20when%20there%20are%20any%20openings." },
                            ]}
                        />
                        <FooterLinkSection
                            title="Donors"
                            links={[
                                { name: "I'd like to be a sponsor", url: '#/sponsor-levels' },
                                { name: "501c3 Tax Determination Letter", url: 'https://drive.google.com/file/d/1ZCEeDaCKjW6O8pQc-i-EWCv7zdDcAii3/view?usp=drive_link' },
                                { name: "Donor Flier", url: 'https://drive.google.com/file/d/1SWtmiIePvrLatVAoDWQVOWiIK1u1V7Mm/view' },
                                { name: "Get 20% Match!", url: 'https://givebutter.com/FFIcQz' },
                            ]}
                        />

                        <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">

                            <div className="footer-widget">


                                <div className="sidebar-widget-wrapper">

                                    <div className="footer-widget-header clearfix">
                                        <h3>About</h3>
                                    </div>

                                    <p>
                                        Black Hills Robotics Foundation Inc is a 501c3 with minimal overhead. We have no full time or paid staff. We are coaches and parents supporting other coaches and parents.
                                    </p>

                                    <div className="textwidget contact-us">
                                        <span className="fa fa-envelope"></span>
                                        <p>
                                            <a href="mailto:support@blackhillsrobotics.org">support@blackhillsrobotics.org</a>
                                        </p>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>
                </div>

            </section>

            <section className="footer-contents">

                <div className="container">

                    <div className="row clearfix">

                        <div className="col-md-12 col-sm-12 text-center">
                            <p className="copyright-text"> Copyright © 2024, All Right Reserved - Black Hills Robotics Foundation, Inc </p>
                        </div>

                    </div>

                </div>

            </section>

        </footer>
    )
}
